/**
Gli hook si possono utilizzare solo top-level in un componente, e l'hook "useAnalytics" deve essere richiamato da un componente già incluso sotto a un provider di history, come Router.

Purtroppo però, da quando esistono, i componenti che definiscono le App (in src/components/apps) richiamano i Router al loro interno, quindi non posso usare "useHistory" quando definisco una app. Richiamando sotto a <Router> questo componente posso usare l'hook a top level E essere sotto <Router>.
 */

import { IConfig } from '@food/auth';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
export interface IAnalyticsListenerProps {
	config?: IConfig;
	authManager?: any;
}

export const AnalyticsListener: React.FC<IAnalyticsListenerProps> = (config, authManager) => {
	const { listen } = useHistory();
	(window as any).historyLocations = [];

	console.log(config, authManager);

	useEffect(() => {
		const unlisten = listen((location) => {
			(window as any).historyLocations.push(location);
			track(
				{
					'event': 'virtualPageview',
					'pageUrl': (window as any).location.href,
					'pagePath': (window as any).location.pathname + (window as any).location.hash,
					'isSPA': true
				}
			);
		});
		return unlisten;
	}, [listen]);

	track(
		{
			'event': 'virtualPageview',
			'pageUrl': (window as any).location.href,
			'pagePath': (window as any).location.pathname + (window as any).location.hash,
			'isSPA': true,
			'firstCall': true
		}
	);

	return null;
};

export function track(dataLayer_content: any, uniqueFieldTest?: string) {
	(window as any).dataLayer = (window as any).dataLayer || [];
	if (!uniqueFieldTest || (uniqueFieldTest && (window as any).dataLayer.findIndex(function (item: any) { return item[uniqueFieldTest]; }) === -1)) {
		console.log("Analytics Listener", dataLayer_content, uniqueFieldTest);
		(window as any).dataLayer.push(dataLayer_content);
	}
}
